module.exports = __webpack_public_path__ + "img/resource-bg-blue.81c9ef5d.png";